import { ThunkAction } from 'redux-thunk';
import * as Actions from './actions';
import { AnyAction } from 'redux';
import { getCookie } from '../../utils/cookie';

export const setUserFromCookie = (): ThunkAction<
  {},
  {},
  {},
  AnyAction
> => async dispatch => {
  const accessToken = getCookie('access_token');
  const refreshToken = getCookie('refresh_token');
  const userId = getCookie('user_id');
  const email = getCookie('email');
  const phoneNumber = getCookie('phone_number');

  if (accessToken !== undefined) {
    dispatch(Actions.setAccessToken(accessToken));
  }
  if (refreshToken !== undefined) {
    dispatch(Actions.setRefreshToken(refreshToken));
  }
  if (userId !== undefined) {
    dispatch(Actions.setUserId(userId));
  }
  if (email !== undefined) {
    dispatch(Actions.setEmail(email));
  }
  if (phoneNumber !== undefined) {
    dispatch(Actions.setPhoneNumber(phoneNumber));
  }
};
